export const CRASH_GAME = '/crash-game'
export const PLINKO_GAME = '/plinko-game'
export const MINE_GAME = '/mine-game'
export const CROSS_GAME = '/cross-game'
export const TOWER_GAME = '/tower-game'
export const DICE_GAME = '/dice-game'
export const KENO_GAME = '/keno-game'
export const HILO_GAME = '/hilo-game'
export const COIN_FLIP_GAME = '/coin-flip-game'
export const WALLET = '/wallet'
export const SYSTEM = '/system'

const NAMESPACES = {
  CRASH_GAME: '/crash-game',
  AZTECMAN_GAME: '/aztecman-game',
  FOLLOW_THE_ARROW_GAME: '/follow-the-arrow-game',
  POWER_OF_THOR_GAME: '/power-of-thor-game',
  CHAT: '/chat'
}

export default NAMESPACES
